<div class="modal-header">
  <h5 class="modal-title fs-3">{{"USERS.CHANGE_PASSWORD.TITLE" | translate}}</h5>
  <span
    class="btn btn-icon btn-sm btn-active-light-primary" aria-label="Close"
    (click)="closeModal()"
    inlineSVG="./assets/media/icons/duotune/arrows/arr011.svg"
  ></span>
</div>
<div class="px-10 py-0 modal-body">
  <form [formGroup]="userForm">
    <div class="card mb-5 mb-xl-8 pt-5">
      <div class="card-body py-3">
        <div class="row my-6">
          <div class="col-6">
            <label class="form-label mb-3 fs-4 required">{{"USERS.CHANGE_PASSWORD.NEW_PASSWORD" | translate}}</label>
          </div>
          <div class="col-6">
            <div class="d-flex">
              <app-validation-message>
                <div class="d-flex flex-grow-1 justify-content-between"
                  [class.is-invalid]="userForm.controls.newPassword.dirty && userForm.controls.newPassword.invalid">
                  <div class="col-11">
                    <input
                      id="newPassword"
                      formControlName="newPassword"
                      [type]="passwordType | async"
                      class="form-control form-control-lg form-control-solid"
                      [class.is-invalid]="userForm.controls.newPassword.dirty && userForm.controls.newPassword.invalid"
                      placeholder='{{"USERS.CHANGE_PASSWORD.NEW_PASSWORD_PLACEHOLDER" | translate}}'
                    />
                  </div>
                  <div class="ms-3 align-self-center justify-self-center">
                    <i
                      id="showNewPasswordButton"
                      class="bi text-hover-primary cursor-pointer"
                      [ngClass]="showPasswordIconClass"
                      style="font-size: 20px;"
                      (mouseenter)="onChangePasswordType('text')"
                      (mouseleave)="onChangePasswordType('password')"
                    ></i>
                  </div>
                </div>
                <ng-container error>
                  <ng-container *ngIf="isTouchedAndHasError('newPassword', ['required'])">
                    <div>{{'COMMON.VALIDATION.REQUIRED' | translate}}</div>
                  </ng-container>
                  <ng-container *ngIf="isTouchedAndHasError('newPassword', ['minlength'])">
                    <div>{{'USERS.CHANGE_PASSWORD.VALIDATION_MIN_LENGTH' | translate:{ min: MIN_LENGTH} }}</div>
                  </ng-container>
                </ng-container>
              </app-validation-message>
            </div>
          </div>
        </div>
        <div class="row my-6">
          <div class="col-6">
            <label class="form-label mb-3 fs-4 required">{{"USERS.CHANGE_PASSWORD.NEW_PASSWORD_CONFIRMATION" | translate}}</label>
          </div>
          <div class="col-6">
            <div class="d-flex">
              <app-validation-message>
                <div class="d-flex flex-grow-1 justify-content-between"
                  [class.is-invalid]="userForm.controls.newPasswordConfirmation.dirty && (userForm.controls.newPasswordConfirmation.invalid || userForm.errors?.matchPassword)">
                  <div class="col-11">
                    <input
                      id="newPasswordConfirmation"
                      formControlName="newPasswordConfirmation"
                      [type]="confirmationPasswordType | async"
                      class="form-control form-control-lg form-control-solid"
                      [class.is-invalid]="userForm.controls.newPasswordConfirmation.dirty && (userForm.controls.newPasswordConfirmation.invalid || userForm.errors?.matchPassword)"
                      placeholder='{{"USERS.CHANGE_PASSWORD.NEW_PASSWORD_CONFIRMATION_PLACEHOLDER" | translate}}'
                    />
                  </div>
                  <div class="align-self-center justify-self-center">
                    <i
                      id="showNewConfirmationPasswordButton"
                      class="bi text-hover-primary cursor-pointer"
                      [ngClass]="showConfirmationPasswordIconClass"
                      style="font-size: 20px;"
                      (mouseenter)="onChangeConfirmationPasswordType('text')"
                      (mouseleave)="onChangeConfirmationPasswordType('password')"
                    ></i>
                  </div>
                </div>
                <ng-container error>
                  <ng-container *ngIf="isTouchedAndHasError('newPasswordConfirmation', ['required'])">
                    <div>{{'COMMON.VALIDATION.REQUIRED' | translate}}</div>
                  </ng-container>
                  <ng-container *ngIf="isTouchedAndHasError('newPasswordConfirmation', ['minlength'])">
                    <div>{{'USERS.CHANGE_PASSWORD.VALIDATION_MIN_LENGTH' | translate:{ min: MIN_LENGTH} }}</div>
                  </ng-container>
                  <ng-container *ngIf="userForm.errors?.matchPassword">
                    <div>{{'USERS.CHANGE_PASSWORD.VALIDATION_MISMATCH' | translate}}</div>
                  </ng-container>
                </ng-container>
              </app-validation-message>
            </div>
          </div>
        </div>
        <div class="card-footer d-flex justify-content-end pt-6 px-0">
          <button type="button" class="btn btn-primary" [disabled]="!userForm.valid" (click)="onSaveClick()">{{"USERS.CHANGE_PASSWORD.SAVE_BUTTON" | translate}}</button>
        </div>
      </div>
    </div>
  </form>
</div>
